<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSearch='false' @load="load" @reset="reset"
                 title="Từ khóa chung" titleIcon="fa fa-tags">
            <template slot="actionBefore">
                <b-tabs class="c-tabs-button mr-2" small pills @input="load">
                    <b-tab v-for="option in typeOptions" :key="option.value" :title="option.text + ' (' + (params.dataKeyword[option.value] ? params.dataKeyword[option.value] : '0') + ')'" @click="search(option.value)"></b-tab>
                </b-tabs>
            </template>
            <template slot="filter">
            </template>
            <template #cell(name)="{item}">
                <span :class="(item.blocked ? 'c-signal' : 'c-signal is-success')"><span class="h-word-break">{{item.name}}</span></span>
            </template>
            <template slot="action">
                <g-button :loading="saveLoading" v-if="permissions('keyword_create')"  size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(action)="{item}">
                <!-- <a class="btn btn-sm btn-outline-gray ml-1 mb-1" :href='getLink(`/bai-viet/tu-khoa/${item.slug}.html`)' target="_blank" ><i class='fa fa-eye'></i></a> -->
                <!-- <g-button size="sm" variant="outline-gray" class="ml-1 mb-1" icon="fa fa-copy" @click="copy(getLink(`/bai-viet/tu-khoa/${item.slug}.html`))" /> -->

                <g-button v-if="permissions('keyword_update')"  :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('keyword_del')"  :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <form-select label="Loại thẻ" :model="formModel" attribute="type" :errors="formErrors" :options="typeOptions"  />
            <form-input label="Tên thẻ" :required='true' :model="formModel" attribute="name" :errors="formErrors" desc="Tên riêng sẽ hiển thị trên website của bạn" />
            <form-input label="Đường dẫn" :required='true' :model="formModel" attribute="slug" :errors="formErrors" desc="Chuỗi cho đường dẫn tĩnh là phiên bản của tên hợp chuẩn với Đường dẫn (URL). Chuỗi này bao gồm chữ cái thường, số và dấu gạch ngang (-)." />
            <form-checkbox chk-label="Tạm ẩn trên website" :model="formModel" :errors="formErrors"  attribute="blocked" />

            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    // import FormMedia from '@/components/media/FormMedia';

    export default {
        components: {},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadKeyword",
                service: '/keyword',
                fields: [
                    {key: 'name', label: "Tên thẻ", class: 'text-left'},
                    {key: 'slug', label: "Đường dẫn", class: 'text-left'},
                    {key: 'post_count', label: "Số bài viết", class: 'text-right'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: '',
                    type: 1
                },
                defaultFormModel: {
                    name: null,
                    slug: null,
                    blocked: null,
                    type: 1
                },
                typeOptions: [
                    {value: 1, text: "Từ khoá chung"},
                    {value: 2, text: "Tin tức và sự kiện"},
                    {value: 3, text: "Quản lý và chính sách"},
                    {value: 4, text: "Dữ liệu"},
                    {value: 5, text: "Điểm đến xanh"},
                    {value: 6, text: "Dịch vụ công"},

                ],
            }

        },
        watch: {
            "formModel.name": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.slug": {
                handler(val) {
                    if (val) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            }
        },
        methods: {
            search(val) {
                this.filterFormModel.type = val;
                this.load();
            },
            reset() {
                this.filterFormModel.type = 'common';
                this.filterFormModel.keyword = '';
                this.$router.go(this.$router.currentRoute)
            },
        },
        mounted() {
        }
    }
</script>